export const shellSelectors = {
	cayuseHeader: (state) => state.shell.cayuseHeader,
	isFetching: (state) => state.shell.isFetching,
	locale: (state) => state.shell.locale,
	user: (state) => state.shell.content.user,
	userAccess: (state) => state.shell.content.userAccess,
};
